import React from 'react';
export function CollectionFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 110-2h13V7a1 1 0 011-1z"
  }));
}